import React, {useContext} from 'react';
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import {RouteContext} from "./context/RouteContext";
import {FormattedMessage} from "react-intl";

const RouteState = (data) => {

    const {viewModel} = useContext(RouteContext)

    const getValue = (state) => {
        switch (state) {
            case "Induct":
                return viewModel.routeState.inducted
            case "Picked":
                return viewModel.routeState.picked
            case "Stowed":
                return viewModel.routeState.stowed
            case "Staged":
                return viewModel.routeState.staged
            case "Departed":
                return viewModel.routeState.departed
            default:
                return ""
        }
    }

    return (
        <Box type="outline" spacingInset="large" minWidth="fit-content">
            <Text type="h300">
               <FormattedMessage id={data.detail.state} defaultMessage={data.detail.message}/>
            </Text>
            <Text type="d50">{getValue(data.detail.message)}</Text>
        </Box>
    )
}

export default RouteState


// WEBPACK FOOTER //
// ./src/components/routeView/RouteState.js